//this is single product page

import React, { useEffect, useState } from "react";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer";
import Axios from "../../axios/axios";
import { Link } from "react-router-dom";

import { getSingleProductsList } from "../../actions/ProductPageAction";
import { useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ConfirmModal from "../../components/utils/ConfirmModal";

const Product = () => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const singleProduct_ = useSelector((state) => state.singleProductList);
  const { loading, error, singleproduct } = singleProduct_;

  const [isloading, setIsloading] = useState(false);

  const [product, setProduct] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [availability, setAvailability] = useState("");
  const [days, setDays] = useState(1);
  const [totalAmount, settotalAmont] = useState("");

  const [user, setUser] = useState("");
  const [cartAdd, setAddCart] = useState("");
  const [IsAdded, setIsAdded] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const [productsByCategory, setProductsByCategory] = useState([]);
  const [productsByBrand, setProductsByBrand] = useState([]);

  const [cart, setCart] = useState([]);

  const [userInfo, setUserInfo] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalAction, setModalAction] = useState(null);

  useEffect(() => {
    if (id) {
      dispatch(getSingleProductsList(id));
    }
  }, [dispatch, id]);

  const fetchData = async () => {
    try {
      // Fetch products by categorywise

      const categoryResponse = await Axios.get(
        `/api/products/bycategory/${singleproduct?.category?._id}`,
      );

      setProductsByCategory(categoryResponse.data);

      // Fetch products by brandwise
      const brandResponse = await Axios.get(
        `/api/products/bybrand/${singleproduct?.brand?._id}`,
      );
      setProductsByBrand(brandResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (singleproduct?.category != null) {
      fetchData();
    }
    const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
    setUserInfo(storedUserInfo);
  }, [singleproduct]);
  // Run once when the component mounts

  useEffect(() => {
    fetchCart();
  }, []);
  const [today, setToday] = useState("");

  useEffect(() => {
    // Function to get today's date in "YYYY-MM-DD" format
    const getTodayDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    setToday(getTodayDate());

    // Set the initial value of startDate to today's date
    setStartDate(getTodayDate());
    setEndDate(getTodayDate());
  }, []);

  console.log(startDate, "st");
  console.log(endDate, "Ed");

  const fetchCart = async () => {
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
      const response = await Axios.get(`api/cart/${storedUserInfo._id}`);
      setCart(response?.data?.product);
      console.log(response?.data?.product);
    } catch (error) {
      console.log("Error fetching cart list:", error.message);
    }
  };

  const validateRentalDates = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    if (start < today) {
      toast.error("Past dates are not allowed.");
      return false;
    }

    if (Number(days) < 1) {
      toast.error("Minimum rental period is 1 day.");
      return false;
    }

    const end = new Date(start);
    end.setDate(end.getDate() + Number(days) - 1);

    if (end < start) {
      toast.error("Invalid rental dates.");
      return false;
    }

    return true;
  };

  const handleStartDate = (e) => {
    const value = e.target.value;

    setStartDate(value);

    if (!value) return;

    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const selected = new Date(value);
    selected.setHours(0, 0, 0, 0);

    if (selected < todayDate) {
      toast.error("Past dates are not allowed.");

      // Reset back to today
      setStartDate(today);
      return;
    }
  };

 const handleDays = (e) => {
  const value = e.target.value;

  // Allow user to clear the field while typing
  if (value === "") {
    setDays("");
    return;
  }

  if (Number(value) < 1) {
    toast.error("Days must be at least 1");
    setDays(1);
    return;
  }

  setDays(Number(value));
};

const handleQuantity = (e) => {
  const value = e.target.value;

  if (value === "") {
    setQuantity("");
    return;
  }

  if (Number(value) < 1) {
    toast.error("Quantity must be at least 1");
    setQuantity(1);
    return;
  }

  setQuantity(Number(value));
};

  // add to cart////////////////////
  const addToCart = async () => {
    setIsloading(true);
    if (!validateRentalDates()) {
      setIsloading(false);
      return;
    }

    try {
      // Validate days and quantity
      if (days < 1 || quantity < 1) {
        toast.error("Days and quantity must be greater than or equal to one.");
        setIsloading(false);
        return;
      }

      // Perform availability check
      const availabilityCheckData = {
        startDate,
        endDate,
        product: id,
        qnty: quantity,
      };

      const availabilityRes = await Axios.post(
        `api/order/check`,
        availabilityCheckData,
      );

      if (availabilityRes.data.code === 200) {
        if (availabilityRes.data.balStock < quantity) {
          toast.error(
            `Only ${availabilityRes.data.balStock} stock are available`,
          );
          setIsloading(false);
          return; // Stop further execution
        } else {
          toast.success(`Available`);
        }
      } else {
        toast.error("Items Not available for this date");
        setIsloading(false);
        return; // Stop further execution
      }

      // Proceed to add the product to the cart
      const CalcAmount = singleproduct.offerPrice * days * quantity;
      const amount = singleproduct.offerPrice;

      // Check if the user is logged in
      if (!userInfo) {
        setModalMessage(
          "Please login to add items to your cart. \nDo you want to login?",
        );
        setModalAction(() => () => {
          setModalOpen(false);
          window.location.href = "/login";
        });
        setModalOpen(true);
        setIsloading(false);
        return;
      }

      const price = singleproduct?.offerPrice;

      const data = {
        user: userInfo?._id,
        totalAmount: CalcAmount,
        product: id,
        startDate,
        endDate,
        days,
        qnty: quantity,
        amount: amount,
      };
      console.log(quantity);
      console.log(data);

      const res = await Axios.post(`api/cart`, data);

      if (res.data.code === 200) {
        setAddCart(res.data.code);
        toast.success("Successfully added to cart");

        // Mark product as added
        setIsAdded(true);

        // Refresh cart list to sync
        fetchCart();
      } else {
        setAddCart(res.data.code);
      }
    } catch (error) {
      console.log("Error during add to cart: ", error.message);
      toast.error("Error adding to cart");
    } finally {
      setIsloading(false);
    }
  };

  //book now

  const booknow = async () => {
    setIsloading(true);

    if (!validateRentalDates()) {
      setIsloading(false);
      return;
    }

    try {
      // Validate days and quantity
      if (days < 1 || quantity < 1) {
        toast.error("Days and quantity must be greater than or equal to one.");
        setIsloading(false);
        return;
      }

      // Perform availability check
      const availabilityCheckData = {
        startDate,
        endDate,
        product: id,
        qnty: quantity,
      };

      const availabilityRes = await Axios.post(
        `api/order/check`,
        availabilityCheckData,
      );

      if (availabilityRes.data.code === 200) {
        if (availabilityRes.data.balStock < quantity) {
          toast.error(
            `Only ${availabilityRes.data.balStock} stock are available`,
          );
          setIsloading(false);
          return; // Stop further execution
        } else {
          toast.success(`Available`);
        }
      } else {
        toast.error("Items Not available for this date");
        setIsloading(false);
        return; // Stop further execution
      }

      // Proceed to add the product to the cart
      const CalcAmount = singleproduct.offerPrice * days * quantity;
      const amount = singleproduct.offerPrice;

      // Check if the user is logged in
      if (!userInfo) {
        setModalMessage(
          "Please login to book this now.\nDo you want to login?",
        );
        setModalAction(() => () => {
          setModalOpen(false);
          window.location.href = "/login";
        });
        setModalOpen(true);
        setIsloading(false);
        return;
      }

      const price = singleproduct?.offerPrice;

      const data = {
        user: userInfo?._id,
        totalAmount: CalcAmount,
        product: id,
        startDate,
        endDate,
        days,
        qnty: quantity,
        amount: amount,
      };
      console.log(quantity);
      console.log(data);

      const res = await Axios.post(`api/cart`, data);

      if (res.data.code === 200) {
        setAddCart(res.data.code);
        toast.success("Added to cart");
        window.location.href = "/cart";
      } else {
        setAddCart(res.data.code);
      }
    } catch (error) {
      console.log("Error during add to cart: ", error.message);
      toast.error("Error adding to cart");
    } finally {
      setIsloading(false);
    }
  };

  // search availability of product/////////////////
  const availabilityCheck = async () => {
    if (!validateRentalDates()) return;
    try {
      if (days < 1 || quantity < 1) {
        toast.error("Days and quantity must be greater than or equal to one.");
        setIsloading(false);
        return;
      }

      const data = {
        startDate,
        endDate,
        product: id,
        qnty: quantity,
      };

      console.log(data);

      const res = await Axios.post(`api/order/check`, data);
      if (res.data.code === 200) {
        if (res.data.balStock < quantity) {
          toast.error(`Only ${res.data.balStock} stock are available`);
        } else {
          toast.success(`Available `);
        }
      } else {
        // setAvailability(res.data.code);
        toast.error("Items Not available for this date");
      }
    } catch (error) {
      console.error("Error during availability check:", error);
      toast.error("Error checking availability");
    }
  };

  let isCartAdded = cart?.some((data) => data.product == id);

  // const handleStartDate = (val) => {
  //   setStartDate(val);
  //   handleNumberOfDays(days, val);
  // };

  // const handleNumberOfDays = (val, date_) => {
  //   setDays(val);

  //   const startDate_ = new Date(date_);
  //   startDate_.setDate(startDate_.getDate() + parseInt(val, 10) - 1);

  //   const year = startDate_.getFullYear();
  //   const month = startDate_.getMonth() + 1; // Months are 0-indexed, so add 1
  //   const day = startDate_.getDate();

  //   let date = `${year}-${month < 10 ? "0" : ""}${month}-${
  //     day < 10 ? "0" : ""
  //   }${day}`;

  //   setEndDate(date);
  // };

  // const handleQuantity = (value) => {
  //   setQuantity(value);
  // };

  const headingStyle = {
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#333",
    margin: "20px 0",
    lineHeight: "1.5",
  };

  const price = singleproduct?.offerPrice;

  useEffect(() => {
    if (!startDate) return;

    const start = new Date(startDate);

    if (isNaN(start.getTime())) return;

    const end = new Date(start);

    end.setDate(end.getDate() + Number(days) - 1);

    setEndDate(end.toISOString().split("T")[0]);
  }, [startDate, days]);

  return (
    <body className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content">
            <div className="page-header text-center">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="breadcrumbs">
                      <a href="#" title="Back to the home page">
                        Home
                      </a>
                      <span className="main-title fw-bold">
                        <i className="icon anm anm-angle-right-l"></i>Products
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="product-single">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 product-layout-img mb-4 mb-md-0">
                    <div className="product-details-img product-horizontal-style">
                      <div className="zoompro-wrap">
                        <div className="zoompro-span">
                          <img
                            id="zoompro"
                            className="zoompro"
                            src={
                              singleproduct?.image1
                                ? singleproduct?.image1
                                : "/assets/images/products/noimage.png"
                            }
                            alt="Product"
                            width="325"
                            height="508"
                          />
                        </div>

                        <div className="product-labels"></div>

                        <div className="product-buttons">
                          <a
                            href="#;"
                            className="btn btn-primary prlightbox"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Zoom Image"
                          >
                            <i className="icon anm anm-expand-l-arrows"></i>
                          </a>
                        </div>
                      </div>

                      <div className="lightboximages">
                        <img
                          className="blur-up lazyload"
                          src={
                            singleproduct?.image3 != undefined
                              ? singleproduct?.image3
                              : "/assets/images/products/noimage.png"
                          }
                          alt="product"
                          width="150"
                          height="150"
                        />

                        <img
                          className="blur-up lazyload"
                          src={
                            singleproduct?.image3 != undefined
                              ? singleproduct?.image3
                              : "/assets/images/products/noimage.png"
                          }
                          alt="product"
                          width="150"
                          height="150"
                        />
                      </div>
                      {/* <div class="shippingMsg featureText mt-5">
                        <i class="icon anm anm-clock-r"></i>Estimated Delivery
                        within <b id="fromDate">2 to 3 days</b>
                        <b id="toDate"></b>
                      </div> */}
                      {/* <div class="freeShipMsg featureText" data-price="199">
                        <i class="icon anm anm-truck-r"></i>
                        <b class="freeShip"></b> Free shipping
                      </div> */}

                      {/* <div class="social-sharing d-flex-center mt-2 lh-lg">
                        <span class="sharing-lbl fw-600">Share :</span>
                        <a
                          href="#"
                          class="d-flex-center btn btn-link btn--share share-facebook"
                        >
                          <i class="icon anm anm-facebook-f"></i>
                          <span class="share-title">Facebook</span>
                        </a>
                        <a
                          href="#"
                          class="d-flex-center btn btn-link btn--share share-twitter"
                        >
                          <i class="icon anm anm-twitter"></i>
                          <span class="share-title">Tweet</span>
                        </a>
                        <a
                          href="#"
                          class="d-flex-center btn btn-link btn--share share-pinterest"
                        >
                          <i class="icon anm anm-pinterest-p"></i>{' '}
                          <span class="share-title">Pin it</span>
                        </a>
                        <a
                          href="#"
                          class="d-flex-center btn btn-link btn--share share-linkedin"
                        >
                          <i class="icon anm anm-linkedin-in"></i>
                          <span class="share-title">Linkedin</span>
                        </a>
                        <a
                          href="#"
                          class="d-flex-center btn btn-link btn--share share-email"
                        >
                          <i class="icon anm anm-envelope-l"></i>
                          <span class="share-title">Email</span>
                        </a>
                      </div> */}
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 product-layout-info">
                    <div className="product-single-meta">
                      <h2 className="product-main-title">
                        {singleproduct?.name}
                      </h2>

                      <div className="product-info">
                        <p className="product-stock d-flex">
                          Category:
                          <span className="pro-stockLbl ps-0">
                            <span className="d-flex-center stockLbl instock text-uppercase">
                              {singleproduct?.category?.categoryName}
                            </span>
                          </span>
                        </p>
                        <p className="product-vendor">
                          Brand:
                          <span className="text">
                            <a href="#">{singleproduct?.brand?.brandName}</a>
                          </span>
                        </p>
                      </div>

                      <div className="product-price d-flex-center my-3">
                        <span className="price old-price">
                          {singleproduct?.price}
                        </span>{" "}
                        &nbsp;Per Day
                        <span className="price">
                          ₹{singleproduct?.offerPrice}
                        </span>
                      </div>

                      <hr />
                      <h3
                        className="text-uppercase mb-0"
                        style={{ fontFamily: "sans-serif" }}
                      >
                        {singleproduct?.description}
                      </h3>
                    </div>

                    <div className="product-form product-form-border hidedropdown">
                      <div className="product-action w-100 d-flex-wrap my-3 my-md-4">
                        <div className="col-md-4 mb-4 stretch-card transparent">
                          <p className="mb-4">Work Date</p>
                          <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            min={today}
                            onChange={handleStartDate}
                          />
                        </div>

                        <div className="col-3">
                          <p className="mb-4">Days</p>
                          <input
                            min="1"
                            type="number"
                            className="form-control"
                            required
                            value={days}
                            onChange={handleDays}
                            disabled={startDate === "" ? true : false}
                          />
                        </div>

                        <div className="col-3">
                          <p className="mb-4">Quantity</p>
                          <input
                            min="1"
                            type="number"
                            className="form-control"
                            required
                            value={quantity}
                            onChange={handleQuantity}
                          />
                        </div>

                        {availability === 200 && (
                          <div
                            className="alert alert-success alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            <strong>Items available for this date!</strong>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        )}
                        {availability === 400 && (
                          <div
                            className="alert alert-Danger alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            <strong>Not Available!</strong> Items not available
                            for this date
                            <button
                              type="button"
                              className="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        )}
                      </div>

                      <div>
                        <div className="product-form-submit addcart fl-1 ms-3">
                          <button
                            type="submit"
                            name="add"
                            className="btn btn-lg checkout w-100"
                            onClick={(e) => availabilityCheck()}
                          >
                            CHECK AVAILABILITY
                          </button>
                        </div>
                        <div className="product-form-submit addcart fl-1 ms-3">
                          <div className="row">
                            <div className="col-6">
                              {!IsAdded ? (
                                <button
                                  type="button"
                                  className="btn btn-lg my-4 checkout w-100"
                                  onClick={() => {
                                    setModalMessage(
                                      "Do you want to add this item to your cart?",
                                    );
                                    setModalAction(() => async () => {
                                      setModalOpen(false);
                                      await addToCart();
                                    });
                                    setModalOpen(true);
                                  }}
                                  disabled={isloading}
                                >
                                  {isloading ? "Adding..." : "Add to Cart"}
                                </button>
                              ) : (
                                <Link to="/cart">
                                  <button className="btn btn-lg my-4 checkout w-100">
                                    View Cart
                                  </button>
                                </Link>
                              )}
                            </div>

                            <div className="col-6">
                              <Link to="/products">
                                <button className="btn btn-secondary my-4 w-100">
                                  Continue Shopping
                                </button>
                              </Link>
                            </div>
                          </div>

                          <button
                            type="submit"
                            name="add"
                            className="btn btn-secondary product-form-sold-out d-none"
                            disabled="disabled"
                          >
                            <span>Out of stock</span>
                          </button>
                          <button
                            type="submit"
                            name="add"
                            className="btn btn-secondary product-form-pre-order d-none"
                          >
                            <span>Pre-order Now</span>
                          </button>
                        </div>

                        {cartAdd === 200 && (
                          <div
                            className="alert alert-success alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            <strong>Items available for this date!</strong>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        )}
                        {cartAdd === 400 && (
                          <div
                            className="alert alert-Danger alert-dismissible fade show mt-2"
                            role="alert"
                          >
                            <strong>Not Available!</strong> Items not available
                            for this date
                            <button
                              type="button"
                              className="close"
                              data-dismiss="alert"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Related Products By Category */}
            <section className="section product-slider pb-0">
              <div className="container">
                <div className="section-header">
                  <p className="mb-1 mt-0">Discover Similar</p>
                  <h2>Related Products By Category</h2>
                </div>

                <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-3 g-md-4">
                  {productsByCategory
                    ?.slice(0, 12)
                    .map((categoryResponse, index) => (
                      <div key={index} className="col">
                        <div className="product-box h-100">
                          <div className="product-image">
                            <Link to={`/product/${categoryResponse._id}`}>
                              <img
                                className="primary blur-up lazyload w-100"
                                src={
                                  categoryResponse?.image1 !== ""
                                    ? categoryResponse?.image1
                                    : "/assets/images/products/noimage.png"
                                }
                                alt={categoryResponse.name}
                                title="Product"
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  objectFit: "cover",
                                }}
                              />
                            </Link>
                          </div>

                          <div className="product-details text-left pt-3">
                            <div
                              className="product-name mb-2"
                              style={{
                                fontSize: "0.9rem",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <Link to={`/product/${categoryResponse._id}`}>
                                {categoryResponse.name}
                              </Link>
                            </div>

                            <div
                              className="product-price"
                              style={{ fontSize: "0.85rem" }}
                            >
                              <span className="price old-price text-decoration-line-through me-1">
                                ₹{categoryResponse.price}
                              </span>
                              <span className="price fw-bold">
                                ₹{categoryResponse.offerPrice}
                              </span>
                            </div>

                            {/* <div class="product-review">
                          <i class="icon anm anm-star"></i>
                          <i class="icon anm anm-star"></i>
                          <i class="icon anm anm-star-o"></i>
                          <i class="icon anm anm-star-o"></i>
                          <i class="icon anm anm-star-o"></i>
                          <span class="caption hidden ms-1">3 Reviews</span>
                        </div>  */}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </section>

            {/* Related Products By Brand */}
            <section className="section product-slider pb-0">
              <div className="container">
                <div className="section-header">
                  <p className="mb-1 mt-0">Discover Similar</p>
                  <h2>Related Products By Brand</h2>
                </div>

                <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-3 g-md-4">
                  {productsByBrand?.slice(0, 12).map((brandResponse, index) => (
                    <div key={index} className="col">
                      <div className="product-box h-100">
                        <div className="product-image">
                          <Link to={`/product/${brandResponse._id}`}>
                            <img
                              className="primary blur-up lazyload w-100"
                              src={
                                brandResponse?.image1 !== ""
                                  ? brandResponse?.image1
                                  : "/assets/images/products/noimage.png"
                              }
                              alt={brandResponse.name}
                              title="Product"
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "cover",
                              }}
                            />
                          </Link>
                        </div>

                        <div className="product-details text-left pt-3">
                          <div
                            className="product-name mb-2"
                            style={{
                              fontSize: "0.9rem",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Link to={`/product/${brandResponse._id}`}>
                              {brandResponse.name}
                            </Link>
                          </div>

                          <div
                            className="product-price"
                            style={{ fontSize: "0.85rem" }}
                          >
                            <span className="price old-price text-decoration-line-through me-1">
                              ₹{brandResponse.price}
                            </span>
                            <span className="price fw-bold">
                              ₹{brandResponse.offerPrice}
                            </span>
                          </div>

                          {/* <div class="product-review">
                            <i class="icon anm anm-star"></i>
                            <i class="icon anm anm-star"></i>
                            <i class="icon anm anm-star-o"></i>
                            <i class="icon anm anm-star-o"></i>
                            <i class="icon anm anm-star-o"></i>
                            <span class="caption hidden ms-1">3 Reviews</span>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </div>
      </div>
      <ConfirmModal
        isOpen={modalOpen}
        message={modalMessage}
        onConfirm={modalAction}
        onCancel={() => setModalOpen(false)}
      />
    </body>
  );
};

export default Product;
